import playerResourceTotalStore from "../store/playerResourceTotal";

// Custom hook để sử dụng và cập nhật cấu hình player
const usePlayerResourceTotal = (playerId) => {
    const playerResourceTotals = playerResourceTotalStore((state) => state.playerResourceTotals);
    const updateSingleResourceTotal = playerResourceTotalStore((state) => state.updateSingleResourceTotal);
    const updatePlayerResourceTotal = playerResourceTotalStore((state) => state.updatePlayerResourceTotal);
    const updateMultiplePlayersResourceTotal = playerResourceTotalStore((state) => state.updateMultiplePlayersResourceTotal);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        resourceTotal: playerId == null ? {} : playerResourceTotals[playerId] || {}, // Nếu không có playerId, trả về object rỗng
        playerResourceTotals,
        updateSingleResourceTotal,
        updatePlayerResourceTotal,
        updateMultiplePlayersResourceTotal,
    };
};

export default usePlayerResourceTotal;
